import Wrapper from './components/Wrapper';

const SignupAlbumLayout = {
  Wrapper,
};

export default SignupAlbumLayout;
